import React from "react";

export default function Loader() {
  return (
    <div data-v-b00d14ae="" className="loader-overlay">
      <i className="fas fa-spinner fa-spin" />
    </div>
  );
}
